/* istanbul ignore file */
export { default } from './RadioButton';
